/* eslint-disable max-len */
import React, { useState } from 'react';
// import { Stack, Button, Grid } from '@mui/material';
import DesignGuidelines from './design-guildlines';

const ClroButtonGrid = (props) => {
  const {
    translateObject
  } = props;

  const [visibleDG, setVisibleDG] = useState(false);
  const handleCloseDG = () => {
    setVisibleDG(false);
    localStorage.removeItem('previousUnits');
  };
  const designGuidline = () => {
    setVisibleDG(true);
  };
  return (
    <>
      <div className="design-guideline-wrapper">
        <div className='design-guideline no_drag' onClick={designGuidline} style={{ display: 'flex', alignItems: 'center', justifyContent: 'right', cursor: 'pointer' }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g id="design_services">
              <g id="Vector">
                <path d="M10.8267 7.67308L11.8733 6.62642L9.37333 4.12642L8.32667 5.17308L5.56667 2.41975C5.04667 1.89975 4.2 1.89975 3.68 2.41975L2.41333 3.68642C1.89333 4.20642 1.89333 5.05308 2.41333 5.57308L5.16667 8.32642L2 11.4997V13.9998H4.5L7.67333 10.8264L10.4267 13.5798C11.06 14.2131 11.9133 13.9798 12.3133 13.5798L13.58 12.3131C14.1 11.7931 14.1 10.9464 13.58 10.4264L10.8267 7.67308ZM6.12 7.37975L3.36 4.62642L4.62 3.35975L5.46667 4.20642L4.68 4.99975L5.62 5.93975L6.41333 5.14642L7.38 6.11308L6.12 7.37975ZM11.3733 12.6397L8.62 9.88642L9.88667 8.61975L10.8533 9.58642L10.06 10.3797L11 11.3197L11.7933 10.5264L12.64 11.3731L11.3733 12.6397Z" fill="#75748B" />
                <path d="M13.8067 4.69308C14.0667 4.43308 14.0667 4.01308 13.8067 3.75308L12.2467 2.19308C11.9333 1.87975 11.5 1.99975 11.3067 2.19308L10.0867 3.41308L12.5867 5.91308L13.8067 4.69308Z" fill="#75748B" />
              </g>
            </g>
          </svg>
          <span className='S_Regular' style={{ marginLeft: 8 }}>{translateObject('Design Guidelines')}</span>
        </div>
        {visibleDG && (
          <DesignGuidelines
            visibleDG={visibleDG}
            handleCloseDG={handleCloseDG}
            translateObject={translateObject}
          />
        )}
      </div>
      {/* commented By chandrashekhar becaus un-used code 21-02-2025 */}
      {/* <Grid container spacing={2} style={{ display: 'none' }}>
        <Grid item xs={12} sm={12} md={6} lg={6} >
          <div className="float-l">
            <Stack spacing={2} direction="row">
              <Button
                variant="contained"
                size="small"
                onClick={designGuidline}
                className="button_design_guidelines Primary_Default_Button"
              >
                {translateObject('Design Guidelines')}
              </Button>
              {visibleDG && (
                <DesignGuidelines
                  visibleDG={visibleDG}
                  handleCloseDG={handleCloseDG}
                  translateObject={translateObject}
                />
              )}
            </Stack>
          </div>
        </Grid>
      </Grid> */}
      {/* commented By chandrashekhar becaus un-used code 21-02-2025 */}
    </>
  );
};

export default ClroButtonGrid;
